import { FC } from 'react';
import { Link, Stack } from '@mui/material';

import { ExternalLinkIcon } from '@mopla/ui';

interface ITariffConditionsLinkProps {
	href: string;
	label: string;
}

export const TariffConditionsLink: FC<ITariffConditionsLinkProps> = ({
	href,
	label,
}) => {
	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1}
			data-testid="tariff-conditions-link"
		>
			<ExternalLinkIcon />
			<Link
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				underline="always"
				sx={{
					color: (theme) => theme.palette.primary.main,
					textDecorationColor: (theme) => theme.palette.primary.main,
					typography: 'l1',
				}}
			>
				{label}
			</Link>
		</Stack>
	);
};
